import React from 'react'
import { Panel } from 'rsuite'
import { budgetFormat } from '../../../utils/formatterUtil'

export default function BudgetSummary({ header, budget, duration, withdrawn, balance }) {
  return (
    <Panel header={header} bordered collapsible defaultExpanded>
      <span>
        <h6>{`งบประมาณ ${budget ? budgetFormat(parseFloat(budget)) : 0} บาท`}</h6>
        <br />

        {withdrawn && <h6>{`ขอเบิกแล้ว ${withdrawn ? budgetFormat(parseFloat(withdrawn)) : 0} บาท`}</h6>}
        {withdrawn && <br />}

        {balance && <h6>{`คงเหลือ ${balance ? budgetFormat(parseFloat(balance)) : 0} บาท`}</h6>}
        {balance && <br />}
        
        <span dangerouslySetInnerHTML={{ __html: duration }} />
      </span>
    </Panel>
  )
}
